import { render, staticRenderFns } from "./ViewPage.vue?vue&type=template&id=336f7f8b&"
import script from "./ViewPage.vue?vue&type=script&lang=js&"
export * from "./ViewPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports